/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteUnitInput = {
    id: string;
};
export type apiDeleteUnitMutationVariables = {
    input: DeleteUnitInput;
};
export type apiDeleteUnitMutationResponse = {
    readonly deleteUnit: {
        readonly status: string;
    };
};
export type apiDeleteUnitMutation = {
    readonly response: apiDeleteUnitMutationResponse;
    readonly variables: apiDeleteUnitMutationVariables;
};



/*
mutation apiDeleteUnitMutation(
  $input: DeleteUnitInput!
) {
  deleteUnit(input: $input) {
    status
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteUnitPayload",
    "kind": "LinkedField",
    "name": "deleteUnit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiDeleteUnitMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiDeleteUnitMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f4de2f888fdfcfc5fbda1bdec3e9c460",
    "id": null,
    "metadata": {},
    "name": "apiDeleteUnitMutation",
    "operationKind": "mutation",
    "text": "mutation apiDeleteUnitMutation(\n  $input: DeleteUnitInput!\n) {\n  deleteUnit(input: $input) {\n    status\n  }\n}\n"
  }
};
})();
(node as any).hash = '6f1c4cf5d5a7ae8d45c8d93c6f1c0ee3';
export default node;
